import gql from 'graphql-tag'
import client from '@stores/apollo'
import { ISpace, ITag } from '@api/types'
import { SpaceFragment, TagFragment } from '@api/fragments'
import handleFetchResult from '@utils/handleFetchResult'

const updateQuery = gql`
  mutation UpdateSpace($input: UpdateSpaceInput!) {
    updateSpace(input: $input) {
      space {
        id
        tags {
          ...TagFragment
        }
        calendar {
          id
          calendarName
        }
        name
        comment
        measurements
      }
    }
  }
  ${TagFragment}
`

interface IPayload {
  space: ISpace
}

const mutateHandler = handleFetchResult<IPayload, IPayload>({
  handler: (data) => data,
  name: 'Spaces',
})

export function update(id: string, payload: any) {
  return client.gql
    .mutate({
      mutation: updateQuery,
      variables: {
        input: {
          id,
          name: payload.name,
          comment: payload.comment,
          measurements: payload.measurements,
          spaceType: payload?.spaceType,
          calendarId: payload?.calendarId,
        },
      },
    })
    .then(mutateHandler)
}

const updateSingleUsageTypeQuery = gql`
  mutation UpdateSingleUsageType($input: UpdateUsageTypesMutationInput!) {
    updateUsageTypes(input: $input) {
      spaces {
        ...SpaceFragment
      }
    }
  }
  ${SpaceFragment}
`

export interface IUpdatedUsageType {
  updateUsageTypes: {
    spaces: Array<{ id: string }>
  }
}

const mutateHandler1 = handleFetchResult<IUpdatedUsageType, { id: string }>({
  handler: (data) => data.updateUsageTypes.spaces[0],
  name: 'Spaces',
})

export function updateUsageType(
  id: string,
  usageType: string | undefined
): Promise<Array<{ id: string }> | { id: string }> {
  return client.gql
    .mutate({
      mutation: updateSingleUsageTypeQuery,
      variables: { input: { ids: [id], usageType } },
    })
    .then(mutateHandler1)
}
